import type { JSX } from "solid-js";
// Geometry and focus ring are shared with CoverButton.
import "./CoverButton.css";

type Props = {
	/**
	 * The link's accessible name. It has no content of its own, so there is
	 * nothing else for a screen reader to announce.
	 */
	label: string;
	href: string;
	target?: HTMLAnchorElement["target"];
	rel?: HTMLAnchorElement["rel"];
	class?: string;
	/** For a destination reached in the page, e.g. scrolling to an anchor. */
	onClick?: JSX.EventHandlerUnion<HTMLElement, MouseEvent>;
};

/**
 * `CoverButton`'s counterpart for a card that navigates: a transparent anchor
 * filling its nearest positioned ancestor, so the whole card is the link
 * without the card's own controls sitting inside one.
 *
 * An anchor rather than a button because the affordances of a link are the
 * point here — middle-click, cmd-click, open in new tab, copy address, and the
 * destination shown on hover.
 */
export const CoverLink = (props: Props) => (
	// biome-ignore lint/a11y/useAnchorContent: a cover is empty by design; `label` names it.
	<a
		class={`gvtui-cover gvtui-cover-link ${props.class ?? ""}`}
		aria-label={props.label}
		href={props.href}
		target={props.target}
		rel={props.rel}
		onClick={props.onClick}
	/>
);
